import { DataType } from '../../../components/tablesConfig/filterconfig'
import * as actions from './actions'
import { Actions } from './actions'

export type State = {
  data: DataType[] | []
  loading: boolean
}

const initialState: State = {
  data: [],
  loading: true,
}

const medarbetareReducer = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case actions.LOADING_MEDARBETARE:
      return (state = {
        ...state,
        loading: action.payload.loading,
      })
    case actions.SET_MEDARBETARE:
      return (state = {
        ...state,
        data: action.payload.data,
      })
    default:
      return state
  }
}

export default medarbetareReducer
